export default "/34887f8f847f5d202a469a9dd4881160882f8c6b/ed3e1222f5d7e466f1889a4510f1de5c.svg";